<template>
  <div class="page-container">
    <div class="header">
      <div class="title">实时交易</div>
    </div>
    <div class="search-form">
      <el-form
        class="search-form-content"
        inline
        :model="form"
        label-width="100px"
        :rules="formRules"
        label-position="left">
        <el-row>
          <el-col>
            <el-form-item label="交易创建时间" size="small">
              <div class="time-range-content">
                <div class="quick-time-picker">
                  <div
                    :class="['item', {active: activeIndex === index}]"
                    v-for="(item, index) in timeQuickPickerList"
                    :key="index"
                    @click="handleQuickTimePickerChange(index)"
                  >{{ item }}</div>
                </div>
                <el-date-picker
                  v-model="dateTimeRange"
                  :picker-options="pickerOptions"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :default-time="['00:00:00', '23:59:59']"
                  @change="handleTimeRangeChange"
                  align="right"
                  size="small"/>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item label="交易金额" size="small" prop="minAmount">
              <el-input style="width: 130px;" v-model="form.minAmount" placeholder="最小交易金额"/>
              -
              <el-input style="width: 130px;" v-model="form.maxAmount" placeholder="最大交易金额"/>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-for="(item, index) in formItemList1" :key="index + '1'">
            <el-form-item :label="item.itemLabel" size="small">
              <CommonSelect
                v-model="form[item.value]"
                :needAll="true"
                :options="optionsObj[item.options]"
                :isMultiple="item.isMultiple"
                :needPaging="item.needPaging"
                :pageLoading="item.pageLoading"
                :filterable="item.filterable || false"
                :clearable="item.clearable || false"
                @change="item.change"
                @loadmore="handleLoadMore(item.query)"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="商户号" size="small">
              <el-input v-model="form.shopMerchantId" placeholder="请输入乐刷商户号" clearable/>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-for="(item, index) in formItemList2" :key="index + '2'">
            <el-form-item :label="item.itemLabel" size="small">
              <CommonSelect
                v-model="form[item.value]"
                :needAll="true"
                :options="optionsObj[item.options]"
                :isMultiple="item.isMultiple"
                :needPaging="item.needPaging"
                :pageLoading="item.pageLoading"
                :filterable="item.filterable || false"
                :clearable="item.clearable || false"
                @change="item.change"
                @loadmore="handleLoadMore(item.query)"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="交易单号" size="small">
              <el-input v-model="form.transactionId" placeholder="请输入交易单号"/>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="结算类型" size="small">
              <el-select v-model="form.t0">
                <el-option label="全部" value=""/>
                <el-option v-for="i in optionsObj.settlementTypeOptions" :key="i.value" :label="i.label" :value="i.value"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item size="small">
              <el-button type="primary" @click="handleFormSearch" class="bs-btn">查询</el-button>
              <el-button type="primary" class="bs-btn" :loading="exportLoading" @click="exportTable()">导出查询结果</el-button>
              <el-button @click="exportTable(true)" :loading="exportSettleLoading" type="primary" class="bs-btn">导出清分交易</el-button>
              <el-tooltip content="导出反向交易带负号的、包含交易成功和退款中的清分交易金额" placement="top">
                <i class="el-icon-question"/>
              </el-tooltip>
              <el-button style="margin-left: 10px;" @click="handleFormReset" class="bs-btn2">重置</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="middle-container">
      <div class="middle-row">
        <span>营业收入(元)</span>
        <span class="symbol"/>
        <span>
          收入金额(元)
          <el-tooltip content="包含收款成功+预授权完成成功的交易金额" placement="top">
            <i class="el-icon-question"/>
          </el-tooltip>
        </span>
        <span class="symbol"/>
        <span>
          支出金额(元)
          <el-tooltip content="包含退款成功+撤销成功+冲正成功+预授权完成撤销成功+退款中的交易金额" placement="top">
            <i class="el-icon-question"/>
          </el-tooltip>
        </span>
        <span class="middle-item">{{ sToFixed((summaryData.transAmount - summaryData.refundAmount) / 100) }}</span>
        <span class="middle-item symbol">=</span>
        <span class="middle-item">{{ sToFixed(summaryData.transAmount / 100) }}</span>
        <span class="middle-item subtract symbol"/>
        <span class="middle-item">{{ sToFixed(summaryData.refundAmount / 100) }}</span>
      </div>
      <div class="middle-row">
        <span>交易笔数</span>
        <span class="symbol"/>
        <span>
          收入交易笔数
          <el-tooltip content="包含收款成功+预授权完成成功的交易笔数" placement="top">
            <i class="el-icon-question"/>
          </el-tooltip>
        </span>
        <span class="symbol"/>
        <span>
          支出交易笔数
          <el-tooltip content="包含退款成功+撤销成功+冲正成功+预授权完成撤销成功+退款中的交易笔数" placement="top">
            <i class="el-icon-question"/>
          </el-tooltip>
        </span>
        <span class="middle-item">{{ summaryData.transNum + summaryData.refundNum }}</span>
        <span class="middle-item symbol">=</span>
        <span class="middle-item">{{ summaryData.transNum }}</span>
        <span class="middle-item add symbol"/>
        <span class="middle-item">{{ summaryData.refundNum }}</span>
      </div>
    </div>
    <div class="table-container">
      <el-table :data="table.data" style="width: 100%;" border v-loading="table.loading">
        <el-table-column prop="orderId" label="交易订单号" align="center" min-width="150px"/>
        <el-table-column prop="transCreateTime" label="交易创建时间" align="center" min-width="160px"/>
        <el-table-column prop="transFinishTime" label="交易完成时间" align="center" min-width="160px"/>
        <el-table-column prop="receiveScenes" label="收款场景" align="center" min-width="80px">
          <template slot-scope="{row}">{{ parseValueToChinese(row.receiveScenes, 'receiveScenesOptions') }}</template>
        </el-table-column>
        <el-table-column prop="payType" label="交易方式" align="center" min-width="80px">
          <template slot-scope="{row}">{{ parseValueToChinese(row.payType, 'payTypesOptions') }}</template>
        </el-table-column>
        <el-table-column prop="transType" label="交易类型" align="center" min-width="80px">
          <template slot-scope="{row}">{{ parseValueToChinese(row.transType, 'transTypesOptions') }}</template>
        </el-table-column>
        <el-table-column prop="transStatus" label="交易状态" align="center" min-width="80px">
          <template slot-scope="{row}">
            <span :style="transStatusColor(row.transStatus)">
              {{ parseValueToChinese(row.transStatus, 'transStatusOptions') }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="amount" label="交易金额(元)" align="center" min-width="120px">
          <template slot-scope="{row}">{{ sToFixed(row.amount / 100) }}</template>
        </el-table-column>
        <el-table-column prop="royalty" label="交易标记" align="center" min-width="100px">
          <template slot-scope="{row}">{{ parseValueToChinese(row.royalty, 'royaltyOptions') }}</template>
        </el-table-column>
        <el-table-column prop="cardScheme" label="卡组" align="center" min-width="100px"/>
        <el-table-column prop="t0" label="结算类型" align="center" min-width="80px">
          <template slot-scope="{row}">{{ parseValueToChinese(row.t0, 'settlementTypeOptions') }}</template>
        </el-table-column>
        <el-table-column prop="device" label="收款设备" align="center" min-width="150px"/>
        <el-table-column prop="cashierArea" label="收银点" align="center" min-width="120px"/>
        <el-table-column prop="shop" label="门店" align="center" min-width="180px"/>
        <el-table-column label="操作" align="center" fixed="right" min-width="120px">
          <template slot-scope="{row}">
            <el-button type="text" @click="handleTableView(row)">交易详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-content">
        <el-pagination
          v-if="table.totalCount > 0"
          :page-size="table.pageSize"
          :layout="layout"
          :total="table.totalCount"
          :current-page="table.pageNo"
          @current-change="onChangeCurrentPage"/>
      </div>
    </div>
    <el-dialog title="交易详情" :visible.sync="showDetailDialog" width="900px">
      <el-form inline :model="detailForm" style="width: 100%;" label-width="130px">
        <el-row :gutter="40">
          <el-col :span="12">
            <el-form-item label="交易订单号：">
              <div class="detail-form-row">
                <span id="businessNo">{{ detailForm.orderId }}</span>
                <copy-btn id="#businessNo"/>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="交易流水号：">
              <div class="detail-form-row">
                <span id="businessSerialNo">{{ detailForm.transId || '-' }}</span>
                <copy-btn v-if="detailForm.transId" id="#businessSerialNo"/>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="40">
          <el-col :span="12">
            <el-form-item label="商户简称：">
              <span>{{ detailForm.merchantName || '-' }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="商户号：">
              <span>{{ detailForm.merchantId || '-' }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="40">
          <el-col :span="12">
            <el-form-item label="门店类型：">
              <span>{{ detailForm.shopType | shopTypeFilter }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否计入实收：">
              <span>{{ detailForm.realReceive | realReceiveFilter }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="40">
          <el-col :span="12">
            <el-form-item label="是否乐刷结算：">
              <span>{{ detailForm.liquidation | liquidationFilter }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="结算类型：">
              <span>{{ parseValueToChinese(detailForm.t0, 'settlementTypeOptions') }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="40">
          <el-col :span="12">
            <el-form-item label="原交易订单号：">
              <div class="detail-form-row">
                <span id="originBusinessOrderNo">{{ detailForm.originalOrderId || '-' }}</span>
                <copy-btn v-if="detailForm.originalOrderId" id="#originBusinessOrderNo"/>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="支付源单号：">
              <div class="detail-form-row">
                <span id="payChanelOrderNo">{{ detailForm.channelOrderId || '-' }}</span>
                <copy-btn v-if="detailForm.channelOrderId" id="#payChanelOrderNo"/>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="40">
          <el-col :span="12">
            <el-form-item label="参考号：">
              <span>{{ detailForm.referenceNumber || '-' }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="商户订单号：">
              <div class="detail-form-row">
                <span id="merchantOrderId">{{ detailForm.merchantOrderId || '-' }}</span>
                <copy-btn v-if="detailForm.merchantOrderId" id="#merchantOrderId"/>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="40">
          <el-col :span="12">
            <el-form-item label="卡类型：">
              <span>{{ detailForm.cardType | cardTypeFilter }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="授权码：">
              <span>{{ detailForm.authorizeCode || '-' }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="40">
          <el-col :span="12">
            <el-form-item label="备注：">
              <span>{{ detailForm.attach || '-' }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="设备类型：">
              <span>{{ detailForm.deviceType | deviceTypeFilter }}</span>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button v-if="showRefundBtn" class="bs-btn" type="primary" @click="handleTableRefund">退款</el-button>
        <el-button class="bs-btn" type="primary" @click="showDetailDialog = false">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="交易退款" :visible.sync="showRefundDialog" width="600px">
      <el-form
        ref="refundFormRef"
        inline
        :model="refundForm"
        :rules="refundRules"
        style="width: 100%;"
        label-width="120px">
        <el-form-item label="交易订单号">
          <el-input v-model="refundForm.orderId" disabled/>
        </el-form-item>
        <el-form-item label="交易创建时间">
          <el-input v-model="refundForm.transCreateTime" disabled/>
        </el-form-item>
        <el-form-item label="交易金额（元）">
          <el-input v-model="refundForm.amount" disabled/>
        </el-form-item>
        <el-form-item label="已退金额（元）">
          <el-input v-model="refundForm.refundAmount" disabled/>
        </el-form-item>
        <el-form-item label="退款金额（元）" required prop="excessRefundAmount">
          <el-input clearable :placeholder="`本次最多可退${refundForm.excessAmount}元`" v-model="refundForm.excessRefundAmount">
            <el-button slot="append" type="primary" @click="handleAllAmountRefund">全部退款</el-button>
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" class="bs-btn" @click="showRefundDialog = false">取消</el-button>
        <el-button type="primary" class="bs-btn" @click="handleRefundFormConfirm">确认</el-button>
      </div>
    </el-dialog>
    <el-dialog title="交易退款" :visible.sync="showRefundPasswordDialog" width="400px">
      <el-form inline :model="refundPasswordForm" style="width: 100%;" label-width="100px">
        <el-form-item label="商家管理密码">
          <el-input v-model="refundPasswordForm.password" :type="refundPasswordForm.type">
            <svg-icon slot="suffix" class="icon" :iconClass="refundPasswordForm.icon" @click="handlePasswordIconClick"/>
          </el-input>
        </el-form-item>
      </el-form>
      <p>若忘记商家管理密码，可在【商户端APP-设置-修改手机号和密码】页面找回密码</p>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" class="bs-btn" @click="showRefundPasswordDialog = false">取消</el-button>
        <el-button type="primary" class="bs-btn" :loading="refundLoading" @click="handleRefundPasswordFormConfirm">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import moment from "moment";
import copyBtn from '../../components/CopyBtn/copy-btn.vue';
import CommonSelect from '@/components/CommonSelect.vue';
import { v160Mixins } from "@/mixins/mixinsv160";
import {
  queryShopList,
  queryCashierList,
  queryDeviceList,
  queryTransactionList,
  queryTransactionDetail,
  queryTransactionRefundInf,
  checkBusinessVerifyCode,
  applyDownloadTableData,
} from "@/api/flow";
import {
  debounce,
  sToFixed,
} from "@/utils/index";

const FORMAT_YMD = 'yyyy-MM-DD';
const FORMAT_YM = 'yyyy-MM';
const today = moment().format(FORMAT_YMD);
const startTime = '00:00:00';
const endTime = '23:59:59';
const defaultTime = [`${today} ${startTime}`, `${today} ${endTime}`];

export default {
  name: "flow-new",
  mixins: [v160Mixins],
  components: {
    copyBtn,
    CommonSelect,
  },
  data() {
    const validateAmount = (rule, value, callback) => {
      const reg = /^((\d)*|([0]{1}))(.(\d){0,2})?$/;
      if (!value && !this.form.maxAmount) {
        callback();
      } else if (!value || +value < 0 || !this.form.maxAmount || +this.form.maxAmount < 0) {
        callback(new Error('请输入正确的交易金额'));
      } else if (+value > 999999999.99 || +this.form.maxAmount > 999999999.99) {
        callback(new Error('输入的交易金额数值过大，请重新输入'));
      } else if (!reg.test(value) || !reg.test(this.form.maxAmount)) {
        callback(new Error('最多保留两位小数'));
      } else if (+value > +this.form.maxAmount) {
        callback(new Error('最大金额不能小于最小金额'));
      } else {
        callback();
      }
    };
    const validRefundAmount = (rule, value, callback) => {
      if (!value || +value < 0) {
        callback(new Error('请输入退款金额'));
      } else if (+value > this.refundForm.excessAmount) {
        callback(new Error('输入的交易金额数值超过最大值，请重新输入'));
      } else {
        callback();
      }
    };
    return {
      refundLoading: false,
      timeQuickPickerList: ['今天', '本周', '本月'],
      activeIndex: 0,
      pickerOptions: {
        disabledDate(time) {
          const dayOf3MonthAgo = moment(moment().subtract(6, "month").format(FORMAT_YMD)).valueOf();
          return time < dayOf3MonthAgo || time > moment(`${today} ${endTime}`).valueOf();
        },
      },
      dateTimeRange: defaultTime,
      optionsObj: {
        receiveScenesOptions: [
          { label: '普通收款', value: 0 },
          { label: '收款单', value: 1 },
          { label: '扫码点餐', value: 2 },
        ], // 收款场景
        payTypesOptions: [
          { label: '银行卡', value: 1 },
          { label: '微信', value: 2 },
          { label: '支付宝', value: 3 },
          { label: '银联云闪付', value: 4 }, // 原银联二维码
          { label: '数字人民币', value: 5 },
          { label: '银行卡预授权', value: 6 },
          { label: '支付宝预授权', value: 7 },
          { label: '微信预授权', value: 8 },
          { label: '抖音支付', value: 15 },
        ], // 交易方式
        transTypesOptions: [
          { label: '收款', value: 1 },
          { label: '退款', value: 2 },
          { label: '撤销', value: 3 },
          { label: '冲正', value: 4 },
          { label: '预授权', value: 5 },
          { label: '预授权完成', value: 6 },
          { label: '预授权撤销', value: 7 },
          { label: '预授权完成撤销（退款）', value: 8 },
        ], // 交易类型
        transStatusOptions: [
          { label: '成功', value: 1 },
          { label: '失败', value: 2 },
          { label: '处理中', value: 3 },
        ], // 交易状态
        settlementTypeOptions: [
          { label: 'D1结算', value: 0 },
          { label: 'D0结算', value: 1 },
        ], // 结算类型
        royaltyOptions: [
          { label: '普通交易', value: 0 },
          { label: '分账', value: 1 },
          { label: '其他', value: 2 },
          { label: '普通交易', value: 3 },
        ], // 交易标记
        shopOptions: [], // 门店
        cashierOptions: [], // 收银点
        deviceOptions: [], // 设备
      },
      form: {
        minAmount: "",
        maxAmount: "",
        shopMerchantId: "",
        receiveScenes: ['all'],
        payTypes: ['all'],
        transTypes: ['all'],
        transStatus: ['all'],
        t0: "",
        shopIds: ['all'],
        cashierAreaNos: '',
        deviceIds: '',
        transactionId: "",
      },
      formRules: {
        minAmount: [
          { trigger: ['blur', 'change'], validator: validateAmount },
        ],
      },
      summaryData: {
        transAmount: 0,
        refundAmount: 0,
        transNum: 0,
        refundNum: 0,
      },
      table: {
        loading: false,
        data: [],
        pageNo: 1,
        totalCount: 0,
        pageSize: 10,
      },
      showDetailDialog: false,
      showRefundDialog: false,
      showRefundPasswordDialog: false,
      detailForm: {},
      refundForm: {
        excessRefundAmount: '',
        excessAmount: '',
      },
      refundPasswordForm: {
        payType: '',
        transStatus: '',
        transType: '',
        royalty: '',
        orderId: '',
        transCreateTime: '',
        password: '',
        type: 'password',
        icon: 'hide-pwd',
      },
      refundRules: {
        excessRefundAmount: [
          { required: true, trigger: ['blur', 'change'], validator: validRefundAmount },
        ],
      },
      exportLoading: false,
      exportSettleLoading: false,
      shopType: 1,
      formItemList1: [
        {
          itemLabel: '收款场景',
          value: 'receiveScenes',
          options: 'receiveScenesOptions',
          isMultiple: true,
        },
        {
          itemLabel: '交易方式',
          value: 'payTypes',
          options: 'payTypesOptions',
          isMultiple: true,
        },
        {
          itemLabel: '交易类型',
          value: 'transTypes',
          options: 'transTypesOptions',
          isMultiple: true,
        },
        {
          itemLabel: '交易状态',
          value: 'transStatus',
          options: 'transStatusOptions',
          isMultiple: true,
        },
      ],
      formItemList2: [
        {
          itemLabel: '门店',
          value: 'shopIds',
          options: 'shopOptions',
          isMultiple: true,
          change: this.handleShopChange,
          needPaging: true,
          pageLoading: false,
          pageNo: 1,
          pageSize: 30,
          finished: false,
          query: 'queryMerchantShopList',
        },
        {
          itemLabel: '收银点',
          value: 'cashierAreaNos',
          options: 'cashierOptions',
          change: this.handleCashierChange,
          filterable: true,
          clearable: true,
        },
        {
          itemLabel: '收款设备',
          value: 'deviceIds',
          options: 'deviceOptions',
          filterable: true,
          clearable: true,
        },
      ],
    };
  },
  filters: {
    shopTypeFilter(val) {
      const obj = {
        0: '分店',
        1: '总店',
      };
      return obj[val] || '-';
    },
    realReceiveFilter(val) {
      const obj = {
        true: '是',
        false: '否',
      };
      return obj[val] || '-';
    },
    liquidationFilter(val) {
      const obj = {
        true: '是',
        false: '否',
      };
      return obj[val] || '-';
    },
    cardTypeFilter(val) {
      const obj = {
        // 0: '未知',
        1: '借记卡',
        2: '贷记卡',
      };
      return obj[val] || '其他';
    },
    deviceTypeFilter(val) {
      const obj = {
        [-1]: '未知',
        1: '码牌',
        2: 'PC插件',
        3: '商户端APP',
        4: 'POS',
      };
      return obj[val] || '-';
    },
  },
  computed: {
    loginInfo() {
      const info = localStorage.getItem('LOGIN_INFO');
      return info ? JSON.parse(info) : {};
    },
    exportTable() {
      return debounce(this.exportTableFunc, 500, true);
    },
    showRefundBtn() {
      /**
       * 交易方式=微信、支付宝、银联二维码、数字人民币
       * 状态=成功
       * 交易类型=收款
       * 老板、店长账号
       * 展示退款按钮
       * */
      const b1 = [2, 3, 4, 5].includes(this.refundPasswordForm.payType) && this.refundPasswordForm.transStatus === 1 && this.refundPasswordForm.transType === 1;
      return b1 && (this.loginInfo.userRole === 1 || this.loginInfo.isBoss === 1);
    },
    layout() {
      const layout = 'total, prev, pager, next, jumper';
      return this.table.totalCount > 9999 ? 'total, prev, next' : layout;
    },
    transStatusColor() {
      return (val) => {
        const mapColor = {
          1: '#008cff', // 蓝色
          2: '#ff9c00', // 橙色
          3: '#a6a6ae', // 灰色
        };
        return `color: ${mapColor[val]};`;
      };
    },
  },
  mounted() {
    if (this.loginInfo) this.shopType = this.loginInfo.shopType;
    this.initData();
  },
  methods: {
    sToFixed,
    initData() {
      this.queryMerchantShopList();
      this.queryMerchantCashierList();
      this.queryMerchantDeviceList();
      this.queryTableData();
    },
    handleLoadMore(queryFunc) {
      if (queryFunc) this[queryFunc]();
    },
    /**
    * 门店查询
    * */
    queryMerchantShopList() {
      const shop = this.formItemList2.find(v => v.itemLabel === '门店');
      const { pageNo, finished, pageSize } = shop;
      if (finished) return false;
      shop.pageLoading = true;
      queryShopList({ pageNo, pageSize }).then(({ data: { code, data } }) => {
        shop.pageLoading = false;
        if (code === '0') {
          const newList = data.list.map(i => ({ label: `${i.shopName} ${i.shopId}`, value: i.shopId }));
          this.optionsObj.shopOptions = [...this.optionsObj.shopOptions, ...newList];
          if (newList.length < pageSize) {
            shop.finished = true;
          } else {
            shop.pageNo += 1;
          }
        }
      });
      return true;
    },
    /**
     * 收银点查询
     * */
    queryMerchantCashierList() {
      this.form.cashierAreaNos = '';
      const { shopIds } = this.form;
      const params = { shopIds: shopIds.filter(i => i !== 'all') };
      queryCashierList(params).then(({ data: { code, data } }) => {
        if (code === '0') {
          this.optionsObj.cashierOptions = data.map(i => ({
            label: `${i.cashierAreaName} ${i.cashierAreaNo}`,
            value: i.cashierAreaNo,
          }));
        }
      });
    },
    /**
     * 收款设备查询
     * */
    queryMerchantDeviceList() {
      this.form.deviceIds = '';
      const { shopIds, cashierAreaNos } = this.form;
      const params = {
        shopIds: shopIds.filter(i => i !== 'all'),
        cashierAreaNos: cashierAreaNos ? [cashierAreaNos] : [],
      };
      queryDeviceList(params).then(({ data: { code, data } }) => {
        if (code === '0') {
          this.optionsObj.deviceOptions = data.map(i => ({
            label: `${i.deviceName} ${i.deviceId}`,
            value: i.deviceId,
          }));
        }
      });
    },
    handleQuickTimePickerChange(index) {
      this.activeIndex = index;
      let starTimeRange = today;
      let endTimeRange = today;
      if (index === 1) {
        const dayOfToday = moment().day();
        starTimeRange = moment().subtract(dayOfToday - 1, 'day').format(FORMAT_YMD);
        endTimeRange = moment().add(7 - dayOfToday, 'day').format(FORMAT_YMD);
      } else if (index === 2) {
        const currentMonth = moment().format(FORMAT_YM);
        starTimeRange = moment(currentMonth).format(FORMAT_YMD);
        endTimeRange = moment(currentMonth).add(1, 'month').subtract(1, 'day').format(FORMAT_YMD);
      }
      this.dateTimeRange = [`${starTimeRange} ${startTime}`, `${endTimeRange} ${endTime}`];
      this.handleFormSearch();
    },
    handleTimeRangeChange(time) {
      const [start, end] = time || [];
      if (moment(end).valueOf() - moment(start).valueOf() > 32 * 24 * 3600 * 1000) {
        this.dateTimeRange = [];
        return this.$message.warning('选择时间跨度不可超过32天');
      }
      this.activeIndex = null;
      return true;
    },
    handleShopChange() {
      this.queryMerchantCashierList();
      this.queryMerchantDeviceList();
    },
    handleCashierChange() {
      this.queryMerchantDeviceList();
    },
    handleFormSearch() {
      this.table.pageNo = 1;
      this.queryTableData();
    },
    handleFormReset() {
      this.form = {
        minAmount: "",
        maxAmount: "",
        shopMerchantId: "",
        receiveScenes: ['all'],
        payTypes: ['all'],
        transTypes: ['all'],
        transStatus: ['all'],
        t0: "",
        shopIds: ['all'],
        cashierAreaNos: '',
        deviceIds: '',
        transactionId: "",
      };
      this.dateTimeRange = defaultTime;
      this.activeIndex = 0;
      this.queryMerchantCashierList();
      this.queryMerchantDeviceList();
      this.handleFormSearch();
    },
    handleSetParams(callback) {
      const [startTime, endTime] = this.dateTimeRange || [];
      if (!startTime || !endTime) {
        this.$message.warning('请选择时间');
        return;
      }
      const {
        minAmount,
        maxAmount,
        shopMerchantId,
        receiveScenes,
        payTypes,
        transTypes,
        transStatus,
        t0,
        shopIds,
        cashierAreaNos,
        deviceIds,
        transactionId,
      } = this.form;
      const params = {
        receiveScenes: receiveScenes.filter(i => i !== 'all'),
        payTypes: payTypes.filter(i => i !== 'all'),
        transTypes: transTypes.filter(i => i !== 'all'),
        transStatus: transStatus.filter(i => i !== 'all'),
        shopIds: shopIds.filter(i => i !== 'all'),
        cashierAreaNos: cashierAreaNos ? [cashierAreaNos] : [],
        deviceIds: deviceIds ? [deviceIds] : [],
        transactionId,
        t0,
        minAmount: minAmount && minAmount * 100,
        maxAmount: maxAmount && maxAmount * 100,
        startTime,
        endTime,
        shopMerchantId,
      };
      callback(params);
    },
    queryTableData() {
      const { pageNo, pageSize } = this.table;
      this.handleSetParams((params) => {
        this.table.loading = true;
        queryTransactionList({ ...params, pageNo, pageSize }).then((res) => {
          const { data: { code, data: { summary = {}, transaction = {} }, msg } } = res;
          this.table.loading = false;
          if (code === '0') {
            this.summaryData = summary;
            this.table.data = transaction.orders;
            this.table.totalCount = transaction.totalCount;
          } else {
            this.errorResult();
          }
        }).catch(() => {
          this.errorResult();
          this.table.loading = false;
        });
      });
    },
    errorResult() {
      this.summaryData = {
        transAmount: 0,
        refundAmount: 0,
        transNum: 0,
        refundNum: 0,
      };
      this.table.data = [];
      this.table.totalCount = 0;
    },
    /**
     * 改变当前页事件
     * @param  {number} pageNo 当前页码
     */
    onChangeCurrentPage(pageNo) {
      this.table.pageNo = pageNo;
      this.queryTableData();
    },
    parseValueToChinese(val, options) {
      const option = this.optionsObj[options].find(i => i.value === val);
      return option ? option.label : '-';
    },
    exportTableFunc(settleFlag) {
      this.handleSetParams((params) => {
        if (settleFlag) {
          params.exportType = 'SETTLE';
          this.exportSettleLoading = true;
        } else {
          this.exportLoading = true;
        }
        applyDownloadTableData(params).then(({ data: { code } }) => {
          this.exportLoading = false;
          this.exportSettleLoading = false;
          if (code === '0') {
            this.$message.success('导出成功，请到下载中心下载报表文件！');
          }
        });
      });
    },
    // 查看详情
    handleTableView(item) {
      const {
        payType, transStatus, transType, orderId, transCreateTime, royalty,
      } = item;
      this.refundPasswordForm.payType = payType;
      this.refundPasswordForm.transStatus = transStatus;
      this.refundPasswordForm.transType = transType;
      this.refundPasswordForm.royalty = royalty;
      this.refundPasswordForm.orderId = orderId;
      this.refundPasswordForm.transCreateTime = transCreateTime;
      queryTransactionDetail({ orderId, transCreateTime }).then(({ data: { code, data } }) => {
        if (code === '0') {
          this.detailForm = data;
          this.showDetailDialog = true;
        }
      });
    },
    handleTableRefund() {
      const { orderId, transCreateTime } = this.refundPasswordForm;
      this.refundForm.excessRefundAmount = '';
      this.refundForm.excessAmount = '';
      this.showDetailDialog = false;
      queryTransactionRefundInf({ orderId, transCreateTime }).then(({ data: { code, data } }) => {
        if (code === '0') {
          this.refundForm.merchantId = this.detailForm.merchantId;
          this.refundForm.orderId = orderId;
          this.refundForm.transCreateTime = transCreateTime;
          this.refundForm.amount = data.amount / 100;
          this.refundForm.refundAmount = data.refundAmount / 100;
          this.refundForm.excessAmount = (data.amount - data.refundAmount) / 100;
          this.showRefundDialog = true;
        }
      });
    },
    handleAllAmountRefund() {
      this.refundForm.excessRefundAmount = this.refundForm.excessAmount;
    },
    // 申请退款
    handleRefundFormConfirm() {
      this.$refs.refundFormRef.validate((valid) => {
        if (valid) {
          this.showRefundPasswordDialog = true;
          this.refundPasswordForm.password = '';
        }
      });
    },
    handlePasswordIconClick() {
      if (this.refundPasswordForm.type === 'password') {
        this.refundPasswordForm.type = '';
        this.refundPasswordForm.icon = "show-pwd";
      } else {
        this.refundPasswordForm.type = "password";
        this.refundPasswordForm.icon = "hide-pwd";
      }
    },
    handleRefundPasswordFormConfirm() {
      this.refundLoading = true;
      const refundAmount = this.refundForm.excessRefundAmount * 100;
      const { password, orderId, royalty } = this.refundPasswordForm;
      const { merchantOrderId } = this.detailForm;
      const refundPassword = this.$md5(password);
      const merchantId = this.refundForm.merchantId;
      const isBoss = this.loginInfo.isBoss;
      checkBusinessVerifyCode({
        merchantId, refundPassword, orderId, refundAmount, royalty, merchantOrderId, isBoss,
      }).then(({ data }) => {
        if (data.error_code === 0) {
          this.$message.success('退款成功');
          this.showRefundPasswordDialog = false;
          this.showRefundDialog = false;
        }
      }).finally(() => {
        this.refundLoading = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.blue {
  color: #008cff;
}

.orange {
  color: #ff9c00 !important;
}

.page-container {
  > .header {
    padding-left: 50px;
    background-color: #fff;

    .title {
      position: relative;
      height: 80px;
      font-size: 18px;
      line-height: 80px;
      color: #333;

      &::after {
        position: absolute;
        right: 0;
        bottom: 0;
        left: -50px;
        display: block;
        height: 0;
        content: "";
        border-bottom: 1px solid #f2f3f3;
      }
    }
  }

  .search-form {
    padding: 40px 50px 20px;
    border-bottom: 20px solid #eee;

    .search-form-content {
      /deep/ .el-select,
      /deep/ .el-input {
        width: 210px;
      }
    }

    .time-range-content {
      display: flex;

      .quick-time-picker {
        display: flex;

        .item {
          flex: 1;
          width: 100px;
          min-width: 100px;
          height: 32px;
          margin-right: 14px;
          font-size: 14px;
          line-height: 32px;
          color: #5e5e63;
          text-align: center;
          cursor: pointer;
          border: 1px solid #dde0e7;

          &.active {
            color: #008cff;
            border: 1px solid #008cff;
          }
        }
      }
    }
  }

  .middle-container {
    display: flex;
    padding: 20px 50px;
    background: #fff;
    border-bottom: 20px solid #eee;

    .middle-row {
      display: grid;
      grid-template-columns: repeat(5, auto);
      margin-right: 40px;

      span {
        box-sizing: content-box;
        display: inline-block;
        min-height: 40px;
        padding: 0 10px;
        line-height: 40px;
        text-align: center;

        &.symbol {
          width: 20px;
        }

        &.middle-item {
          font-size: 24px;
          font-weight: bold;
          color: #008cff;

          &.subtract,
          &.add {
            position: relative;

            &::after {
              position: absolute;
              top: 50%;
              left: 50%;
              display: block;
              width: 16px;
              height: 4px;
              content: "";
              background-color: #008cff;
              transform: translate(-50%, -50%);
            }
          }

          &.add {
            &::before {
              position: absolute;
              top: 50%;
              left: 50%;
              display: block;
              width: 4px;
              height: 16px;
              content: "";
              background-color: #008cff;
              transform: translate(-50%, -50%);
            }
          }
        }
      }
    }
  }

  .table-container {
    padding: 40px 50px 0;
    background: #fff;

    .refund {
      color: #ff9c00 !important;
    }

    .pagination-content {
      margin-top: 10px;
      text-align: center;
    }
  }

  .detail-form-row {
    display: flex;
    justify-content: space-between;
  }

  .dialog-footer {
    text-align: center;
  }

  .el-dialog {
    .el-form-item {
      display: flex;
      width: 100%;

      /deep/ .el-form-item__content {
        flex: 1;
      }
    }
  }
}
</style>
